import { ROUTES } from '@/constants/corporateRoutePaths'
import {
  FormStates,
  FORM_TRANSITIONS,
  type StateValue,
} from '@/panels/corporatesignup/FormStateMachine'

export const STATE_TO_ROUTE: Record<StateValue, string> = {
  [FormStates.CORPINFO]: ROUTES.CORPORATE_INFO,
  [FormStates.CORP_DATE_DETAILS]: ROUTES.CORPORATE_DATE_DETAILS,
  [FormStates.CORP_BUS_ADDRESS]: ROUTES.CORPORATE_BUSINESS_ADDRESS,
  [FormStates.CORP_ADDN_DETAILS]: ROUTES.CORPORATE_ADDITIONAL_DETAILS,
  [FormStates.DIRECTOR_INFO]: ROUTES.DIRECTOR_INFO,
  [FormStates.DIRECTOR_PERSONAL_SHARE]: ROUTES.DIRECTOR_PERSONAL_SHARE,
  [FormStates.DIRECTOR_PEP_INFO]: ROUTES.DIRECTOR_PEP_INFO,
  [FormStates.DIRECTOR_AUTH_INFO]: ROUTES.DIRECTOR_AUTH_INFO,
  [FormStates.CORPDOCS]: ROUTES.CORPORATE_DOCUMENTS,
  [FormStates.CORPORATE_ARTICLE_INCORPORATION]:
    ROUTES.CORPORATE_ARTICLE_INCORPORATION,
  [FormStates.CORPORATE_ASSIST]: ROUTES.CORPORATE_ASSIST,
  [FormStates.COMPLETE]: ROUTES.COMPLETE,
}

export const ROUTE_TO_STATE: Record<string, StateValue> = Object.fromEntries(
  Object.entries(STATE_TO_ROUTE).map(([state, route]) => [
    route,
    state as StateValue,
  ])
)

const walkTransitions = (): StateValue[] => {
  const order: StateValue[] = []
  let state = FormStates.CORPINFO as StateValue

  while (!order.includes(state)) {
    order.push(state)
    state = FORM_TRANSITIONS[state]
  }

  return order
}

export const WIZARD_STATE_ORDER = walkTransitions()

export const WIZARD_ROUTE_ORDER = WIZARD_STATE_ORDER.map(
  (state) => STATE_TO_ROUTE[state]
)
